<template>
 <h1>sites</h1>
</template>

<script>

export default {
	name: 'sites'
}

</script>
